import React, { useState } from "react";
import "./AssignParticipants.css";
import bear_stand from "../../../../images/Starting-Your-Fundraiser/bear_stand.png";
import Popup from "./Popup";
import {
  ManualUploadPopupBody,
  AssignAdminPopupBody,
  UploadExcelPopupBody,
} from "./PopupHandlers";
import { FundraiserSubsequentInfo } from "../../../../Interfaces/Fundraiser";
import { useNavigate } from "react-router-dom";

interface ButtonComponentProps {
  onClick: () => void;
  label: string;
}

const ButtonComponent: React.FC<ButtonComponentProps> = ({
  onClick,
  label,
}) => {
  return (
    <button
      className={"create-fundraiser-assign-participant-button"}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

const AssignParticipants: React.FC<FundraiserSubsequentInfo> = ({
  ...fundraiserProps
}) => {
  type PopupContent = React.ReactNode;
  type PopupHeader = string;

  const fundraiserID: number = fundraiserProps.fundraiserID;
  const [isPopupOpen, setPopupOpen] = useState<boolean>(false);
  const [popupContent, setPopupContent] = useState<PopupContent>(null);
  const [popupHeader, setPopupHeader] = useState<PopupHeader>(
    "This shouldn't be seen"
  );
  const navigate = useNavigate();

  const openPopup = (header: PopupHeader, content: PopupContent) => {
    setPopupHeader(header);
    setPopupContent(content);
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
    setPopupContent(null);
  };

  const handleAssignToAdmin = () => {
    const header: PopupHeader = "Assign to Admin";
    const content: PopupContent = <AssignAdminPopupBody />;

    openPopup(header, content);
  };

  const handleManualUpload = () => {
    const header: PopupHeader = "Manual Upload";
    const content: PopupContent = (
      <ManualUploadPopupBody onClose={closePopup} fundraiserID={fundraiserID} />
    );

    openPopup(header, content);
  };

  const handleUploadExcel = () => {
    const header: PopupHeader = "Upload Excel";
    const content: PopupContent = (
      <UploadExcelPopupBody fundraiser_id={fundraiserID} onClose={closePopup} />
    );
    openPopup(header, content);
  };

  const handleSkip = () => {
    navigate("/dashboard/user");
  };

  return (
    <div className="create-fundraiser-assign-participant-container">
      <div className="create-fundraiser-assign-participant-buttons-container">
        <ButtonComponent
          label="Assign to admin"
          onClick={handleAssignToAdmin}
        />
        <ButtonComponent label="Manual upload" onClick={handleManualUpload} />
        <ButtonComponent label="Upload Excel" onClick={handleUploadExcel} />
        <ButtonComponent label="Upload Later" onClick={handleSkip} />
        <Popup
          popupHeader={popupHeader}
          isOpen={isPopupOpen}
          onBackButton={closePopup}
          content={popupContent}
        />
      </div>
      <img
        src={bear_stand}
        alt="Fundraise with Mamfam"
        className="create-fundraiser-assign-participant-image"
      />
    </div>
  );
};

export default AssignParticipants;
